<template>
  <div>
    <div
      v-if="showMenu"
      v-html="`<style type='text/css'>
      .theo-secondary-color.vjs-control-bar,
        .config-menu {
        opacity: 1 !important;
        }
      </style>`"
    />
    
    <div
      v-if="isBuffering"
      class="buffering-message"
    >
      Buffering? Disable low-latency mode in the advanced settings.

      <button
        class="buffering-message-close-button"
        @click="resetBufferingMessage"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="icon-small"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>

    <div
      v-if="showMenu"
      class="config-menu"
    >
      <div
        v-if="view === 'main'"
        class="flex-column"
      >
        <button
          class="menu-button"
          @click="closeMenu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>

          Close
        </button>

        <button
          v-if="quality"
          class="menu-button"
          @click="view = 'quality'"
        >
          Quality

          <span class="quality-info">
            {{ isAuto ? 'Auto' : '' }} {{ quality.height }}p{{ quality.frameRate > 30 ? '60' : '' }}
          </span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </button>

        <button
          class="menu-button"
          @click="view = 'advanced'"
        >
          Advanced

          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small ml-auto"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </button>

        <button
          class="menu-button"
          @click="view = 'metrics'"
        >
          Metrics

          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small ml-auto"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m8.25 4.5 7.5 7.5-7.5 7.5"
            />
          </svg>
        </button>
      </div>

      <div v-if="view === 'quality'">
        <button
          class="menu-button"
          @click="view = 'main'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>

          Back
        </button>

        <button
          class="menu-button"
          @click="() => selectQuality('auto')"
        >
          <svg
            v-if="isAuto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small mr-1"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          <div
            v-else
            class="radio-circle mr-2"
          />
          Auto
        </button>

        <button
          v-for="(q, index) in qualities"
          :key="q.height"
          class="menu-button"
          @click="() => selectQuality(index)"
        >
          <svg
            v-if="quality.height === q.height"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small mr-1"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
          <div
            v-else
            class="radio-circle mr-2"
          />

          {{ q.height }}p{{ q.frameRate > 30 ? '60' : '' }}
        </button>
      </div>

      <div v-if="view === 'advanced'">
        <button
          class="menu-button mb-2"
          @click="view = 'main'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>

          Back
        </button>

        <b-checkbox
          v-model="isLowLatency"
          size="lg"
          switch
        >
          <div class="checkbox-label">
            Low-latency mode
          </div>
        </b-checkbox>
      </div>

      <div v-if="view === 'metrics'">
        <button
          class="menu-button mb-2"
          @click="view = 'main'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="icon-small"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>

          Back
        </button>

        <div class="metrics-info">
          <div>
            Latency: {{ metrics.currentLatency }}
          </div>
          <div>
            Dropped Frames: {{ metrics.droppedVideoFrames }}
          </div>
          <div>
            Bandwidth: {{ Math.round(metrics.currentBandwidthEstimate / 1024 / 1024) }}MB
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfigMenu',
  props: {
    player: {
      type: Object,
      require: true
    },
    server: {
      type: String,
      require: false
    }
  },
  data () {
    return {
      showMenu: false,
      view: 'main',
      isBuffering: false,
      waitingCount: 0,
      metrics: {},
      isAuto: true,
      quality: {},
      qualities: [],
      isLowLatency: true
    }
  },
  methods: {
    onSettingsClick (e) {
      if (e.target.closest('.theo-settings-control-button')) {
        this.showMenu = !this.showMenu
        e.preventDefault()
      }
    },
    closeMenu () {
      this.showMenu = false
      this.view = 'main'
    },
    selectQuality (index) {
      if (index === 'auto') {
        this.isAuto = true
        this.player.videoTracks[0].targetQuality = null
      } else {
        this.isAuto = false
        this.player.videoTracks[0].targetQuality = this.player.videoTracks[0].qualities[index]
      }

      this.quality = this.player.videoTracks[0].activeQuality
      this.closeMenu()
    },
    checkQuality () {
      this.qualities = this.player.videoTracks[0].qualities
      this.quality = this.player.videoTracks[0].activeQuality

      this.metrics = {
        ...this.player.latency,
        ...this.player.metrics
      }
    },
    resetBufferingMessage () {
      this.isBuffering = false
      this.waitingCount = 0
    },
    onWaiting () {
      this.waitingCount++
      console.log(`waiting #${this.waitingCount}`)
      if (this.waitingCount > 2 && this.isLowLatency) {
        this.isBuffering = true
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.onSettingsClick)
    document.addEventListener('touchend', this.onSettingsClick)
    this.qualities = this.player.videoTracks[0].qualities
    setInterval(this.checkQuality, 1000)

    this.player.addEventListener('waiting', this.onWaiting)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onSettingsClick)
    document.removeEventListener('touchend', this.onSettingsClick)
    clearInterval(this.interval)
  }
}
</script>

<style>
.theoplayer-skin.vjs-has-started.vjs-user-inactive.vjs-playing:not(.theo-menu-opened) .config-menu {
  opacity: 1 !important;
  transition: opacity .5s ease-in-out;
}

.buffering-message {
  position: absolute;
  bottom: 40px;
  border-top: 4px solid #4F83E3;
  font-size: 12px;
  width: 220px;
  right: 0;
  z-index: 100;
  color: white;
  font-weight: 400;
  padding: 0.75rem;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  background-color: #2a2a30;
  padding-right: 1rem;
}

.buffering-message-close-button {
  position: absolute;
  background-color: #2a2a2f;
  border-radius: 9999px;
  padding: 0.25rem;
  transform: translate(6px, -40px);
  border: none;
  cursor: pointer;
}

.icon-small {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
}

.config-menu {
  overflow: hidden;
  padding: 0.75rem;
  position: absolute;
  width: 300px;
  min-height: 250px;
  border-radius: 0.5rem;
  background-color: #2a2a30;
  z-index: 100;
  right: 20px;
  bottom: 40px;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.menu-button {
  width: 100%;
  text-align: left;
  padding-top: 0.5rem;
  padding-bottom: 0.75rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  transition: background-color 0.2s ease-in-out;
  font-size: 15px;
  color: white;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-weight: 400;
}

.menu-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.ml-auto {
  margin-left: auto;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.quality-info {
  margin-left: auto;
  margin-right: 0.75rem;
}

.radio-circle {
  border-radius: 9999px;
  border: 1px solid white;
  width: 13px;
  height: 13px;
  margin-right: 0.5rem;
  flex-shrink: 0;
}

.checkbox-label {
  color: white;
  margin-bottom: -4px;
  margin-left: 0.25rem;
  padding-bottom: 0;
}

.metrics-info {
  color: white;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
</style>